var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.6302 30.75C73.8946 26.0127 67.8602 22.7868 61.2906 21.4803C54.721 20.1738 47.9114 20.8456 41.7237 23.4106C35.536 25.9755 30.2482 30.3184 26.5296 35.8897C22.811 41.4609 20.8286 48.01 20.8333 54.7083L20.8385 59.9166H10.4219V54.7083C10.4192 47.648 12.1051 40.6895 15.339 34.4133C18.5729 28.1372 23.261 22.7256 29.012 18.6301C34.7631 14.5345 41.4102 11.8738 48.3988 10.8701C55.3874 9.86635 62.5147 10.5486 69.1859 12.86C75.8571 15.1714 81.8788 19.0448 86.7484 24.157C91.618 29.2692 95.1943 35.472 97.1788 42.2477C99.1633 49.0233 99.4984 56.1753 98.1563 63.1069C96.8142 70.0385 93.8337 76.5485 89.4635 82.0937L117.297 109.932L109.932 117.297L82.099 89.4583C74.2925 95.6219 64.6338 98.9693 54.6875 98.9583H49.4792V88.5416H54.6875C61.3829 88.5412 67.9279 86.5555 73.4948 82.8355C79.0617 79.1156 83.4006 73.8284 85.9628 67.6426C88.5249 61.4568 89.1954 54.6502 87.8893 48.0834C86.5832 41.5166 83.3592 35.4846 78.625 30.75M8.70833 69.0468L23.4375 83.7812L38.1719 69.0468L45.5365 76.4166L30.8073 91.1458L45.5365 105.875L38.1719 113.245L23.4375 98.5104L8.70833 113.245L1.34375 105.875L16.0729 91.1458L1.34375 76.4166L8.70833 69.0468Z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchError);
export default __webpack_public_path__ + "static/media/search-error.75e9e03a6b6b550f272c86128de7d89b.svg";
export { ForwardRef as ReactComponent };